import { render } from "./WebProfile.vue?vue&type=template&id=1b05449c"
import script from "./WebProfile.vue?vue&type=script&lang=js"
export * from "./WebProfile.vue?vue&type=script&lang=js"

import "./WebProfile.vue?vue&type=style&index=0&id=1b05449c&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__